/**
 * CheckoutCancel
 *
 * Handles Stripe checkout cancellation: clears session flags, finalizes
 * checkout flow in context, and redirects back to pricing.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import AuthLoadingScreen from '../../../components/shared/AuthLoadingScreen';

export default function CheckoutCancel() {
  const navigate = useNavigate();
  const { user, finalizeStripeCheckout } = useAuth();

  useEffect(() => {
    const handleCancel = async () => {
      try {
        // Set a flag to indicate checkout was cancelled
        sessionStorage.setItem('stripe_checkout_cancelled', 'true');
        
        // Clear any stored session data
        localStorage.removeItem('stripeSessionId');
        localStorage.removeItem('stripe_session_id');
        localStorage.removeItem('stripeSessionCreatedAt');
        localStorage.removeItem('stripe_checkout_initiated');
        
        // Finalize the checkout process
        const { returnPath } = finalizeStripeCheckout(false);
        
        console.log('Stripe checkout cancelled, redirecting to:', returnPath);
        
        // Redirect to pricing page with replace:true to avoid back button issues
        navigate(returnPath, { replace: true });
      } catch (error) {
        console.error('Error handling checkout cancellation:', error);
        
        // Fallback to pricing page if something goes wrong
        navigate('/pricing', { replace: true });
      }
    };

    // Short delay to ensure user state is loaded
    const timer = setTimeout(() => {
      if (user) {
        handleCancel();
      } else {
        console.log('No authenticated user found, waiting...');
        
        // If no user after delay, redirect to pricing anyway
        const fallbackTimer = setTimeout(() => {
          navigate('/pricing', { replace: true });
        }, 2000);
        
        return () => clearTimeout(fallbackTimer);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [user, navigate, finalizeStripeCheckout]);

  // Show loading screen while handling cancellation
  return <AuthLoadingScreen message="Returning to pricing page..." />;
} 